module.exports = "/build/web/svg/webshop.32d56e9c2bff9fff2c3b0014b1d7339d.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/webshop.svg
// module id = 237
// module chunks = 24